const eventThemeMapper: Record<string, string> = {
  swissbox: 'newWarehouseSwissbox',
  rentabox24de: 'newWarehouse',
  rentabox24at: 'newWarehouse',
  rentabox24pl: 'newWarehouse',
};

export const getEventThemeByClient = (clientName?: string): string => {
  if (!clientName) {
    return eventThemeMapper.swissbox;
  }

  return eventThemeMapper[clientName] || eventThemeMapper.swissbox;
};
